import React from 'react';

export const CuripodAIStarsSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="33"
    height="29"
    viewBox="0 0 33 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.4839 11.3257C17.9146 9.2444 18.5844 0.279587 18.5844 0.279587C18.5844 0.279587 18.4075 8.65089 21.1005 11.4773C23.3469 13.8352 28.6622 13.6285 29.7076 13.5631C29.8244 13.554 29.8878 13.5503 29.8878 13.5503C29.8878 13.5503 29.8242 13.5558 29.7076 13.5631C28.6709 13.6447 23.4301 14.1641 20.995 16.4656C18.2858 19.0264 17.9982 28.0309 17.9982 28.0309C17.9982 28.0309 17.8921 19.4798 15.3785 16.3141C13.5062 13.9561 9.39262 13.2173 7.67878 13.0067C7.19608 12.9708 6.90547 12.9301 6.90547 12.9301C6.90547 12.9301 7.19739 12.9475 7.67878 13.0067C9.34503 13.1305 13.2993 13.1962 15.4839 11.3257Z"
      fill="url(#paint0_linear_29723_48852)"
    />
    <path
      d="M11.6919 23.8825C12.1548 23.4803 12.1382 21.9383 12.1382 21.9383C12.1382 21.9383 12.2458 23.3696 12.8469 23.7992C13.3484 24.1578 14.4355 24.0193 14.6489 23.9878C14.6727 23.984 14.6857 23.9822 14.6857 23.9822C14.6857 23.9822 14.6727 23.9843 14.6489 23.9878C14.4376 24.022 13.3711 24.2123 12.911 24.6521C12.3991 25.1415 12.4949 26.6828 12.4949 26.6828C12.4949 26.6828 12.3262 25.2265 11.7559 24.7353C11.3313 24.3696 10.4745 24.3235 10.1192 24.3208C10.0196 24.324 9.95922 24.3227 9.95922 24.3227C9.95922 24.3227 10.0194 24.3201 10.1192 24.3208C10.4632 24.3096 11.2757 24.244 11.6919 23.8825Z"
      fill="url(#paint1_linear_29723_48852)"
    />
    <path
      d="M7.15153 19.3765C6.26879 20.2852 6.30569 23.8412 6.30569 23.8412C6.30569 23.8412 6.09535 20.537 4.94598 19.522C3.98702 18.6752 1.91142 18.9509 1.50404 19.0148C1.45853 19.0227 1.43389 19.0265 1.43389 19.0265C1.43389 19.0265 1.45848 19.022 1.50404 19.0148C1.90753 18.9448 3.94343 18.5487 4.82054 17.5531C5.79659 16.4453 5.60851 12.8876 5.60851 12.8876C5.60851 12.8876 5.93559 16.2523 7.02624 17.4075C7.83845 18.268 9.47492 18.4087 10.1534 18.4291C10.3437 18.4256 10.4589 18.431 10.4589 18.431C10.4589 18.431 10.344 18.4348 10.1534 18.4291C9.49636 18.4412 7.94499 18.5598 7.15153 19.3765Z"
      fill="url(#paint2_linear_29723_48852)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_29723_48852"
        x1="17.536"
        y1="2.40403"
        x2="15.3262"
        y2="26.6361"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.278846" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.36" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_29723_48852"
        x1="12.5937"
        y1="21.8512"
        x2="9.93948"
        y2="25.0946"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.259615" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.48" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_29723_48852"
        x1="6.52093"
        y1="13.7237"
        x2="2.38498"
        y2="20.7231"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.424189" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.3" />
      </linearGradient>
    </defs>
  </svg>
);

export default CuripodAIStarsSvg;
